const endpointsStatuses = {
    start: "start",
    inProcess : "inProcess",
    completed: "completed",
    failed: "failed"
}
export default endpointsStatuses